/* eslint-disable no-magic-numbers */
import classNames from 'classnames';
import React, { memo, useEffect, useRef, useState } from 'react';

import { FormattedMessage } from '@futrli/localisation';
import { UISystemIcon } from '@futrli/ui-components';

import * as styles from './banner.scss';

export const Banner = memo(() => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [bannerHeight, setBannerHeight] = useState<number | undefined>();

  useEffect(() => {
    if (ref.current) {
      setBannerHeight(ref.current.offsetHeight);
    }
  }, []);

  return (
    <div
      className={classNames(styles.bannerContainer, {
        [styles.fullHeight]: bannerHeight && window.innerHeight > bannerHeight,
        [styles.flexColumnJustify]: bannerHeight && window.innerHeight > bannerHeight
      })}
      ref={ref}
    >
      <div>
        <UISystemIcon iconName="white-by-sage-logo" width={170} height={77} />
      </div>
      <div>
        <div className={classNames(styles.customerExperience)}>
          <FormattedMessage
            id="register.customer_experience"
            defaultMessage='"Every business owner wants to know what their cash flow is. In the next year, every single one of my clients will have Futrli. It’s a no-brainer. I couldn’t be a bigger champion of Futrli."'
          />
        </div>
        <div className={classNames(styles.flexContainer, styles.customer)}>
          <img src="https://assets.futrli.com/avatars/avatar_ookkee.png" alt="customer" />
        </div>
        <div className={styles.owner}>
          <FormattedMessage id="register.customer_experience_name" defaultMessage="Paul Clarke, Co-Founder, Ookkee" />
        </div>
      </div>
      <div>
        <div className={styles.trustedByTitle}>
          <FormattedMessage
            id="register.truster_top_firms"
            defaultMessage="Trusted by the world’s top accounting firms"
          />
        </div>
        <div className={styles.footerContainer}>
          <UISystemIcon iconName="rsm" width={76} height={32} />
          <UISystemIcon iconName="bdo" width={85} height={32} />
          <UISystemIcon iconName="deloitte" width={171} height={32} />
        </div>
      </div>
    </div>
  );
});
